import "./Contact.scss";

function Contact() {
  return (
    <section className="contact" id="contact">
      <h1 className="page-title">Contact</h1>
      <section className="contactme">
        <p className="medium-font">
          Thanks for stopping by! I would love to chat about programming languages, code architecture and structure, new AI topics and any other interesting IT subjects.
        </p>
        <p className="medium-font">
          Feel free to email me or hit me up on my social media channels.
        </p>
      </section>
    </section>
  )
}

export default Contact;
